import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'digit',
    FormItemProps: {
      label: '数字输入框',
      name: uuid,
    },
  }
};
